import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';
import { Location } from "@angular/common";
import { AlertService } from "src/app/services/alert.service";
import { UserSessionService } from "src/app/services/usersession.service";
import * as _ from "lodash";
import { BookingService } from "src/app/services/booking.service";
import { NavigationService } from "src/app/services/navigation.service";
import { RoleType } from "src/enum/roletype";
import { BookingStatusType } from "src/enum/bookingstatustype";
import { CategoryType } from "src/enum/catergoryType";
import { AeRemarksPopupComponent } from '../remarks-popup/remarks-popup.component';
import { environment } from "src/environments/environment";
import { FarmerService } from 'src/app/services/farmer.service';
import { ApproveStatusType } from 'src/enum/approvestatustype';
import { ApplicationType } from 'src/enum/applicationtype';
import { SecurityService } from 'src/app/services/security.service';


@Component({
  selector: 'app-viewpvtbooking',
  templateUrl: './viewpvtbooking.component.html',
  styleUrls: ['./viewpvtbooking.component.scss']
})
export class ViewpvtbookingComponent implements OnInit {
  hourList: any[] = [];
  filterHourList: any[] = [];
  pdfLink: string;
  public approveStatusType = ApproveStatusType;
  public applicationType = ApplicationType;
  public roleType = RoleType;
  approveCancellationDisabled: boolean = false;
  bookingHistoryapplyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.bookingHistorydataSource.filter = filterValue.trim().toLowerCase();
    if (this.bookingHistorydataSource.paginator) {
      this.bookingHistorydataSource.paginator.firstPage();
    }
  }
  bookingHireDetailViewapplyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.bookingHireDetailViewdataSource.filter = filterValue.trim().toLowerCase();
    if (this.bookingHireDetailViewdataSource.paginator) {
      this.bookingHireDetailViewdataSource.paginator.firstPage();
    }
  }




  id = 0;
  actionInfo = 0;
  form: FormGroup;
  routeParams: any;
  pageTitle: string;
  bookedHireData: any = [];
  isCashBooking: boolean = false;
  submitbtn: string;
  filesResult: any;
  //selectedImage: any;
  licenceTypeList: any[];
  selectedFileName = "Choose File";
  dropdownSettings: any = {};
  vehicleList: any = [];
  formEditMode = true;
  Languages: any[];
  RollList: any;
  passworderror = false;
  isReadOnly = false;
  // isDisable: boolean;
  isDisable = false;
  pattern: RegExp;
  show: boolean;
  show2: boolean;
  clientId: any;
  emailpattern: RegExp;
  machineryAllocatesList: any[];
  filterListmachineryAllocates: any[];
  tommoDate: Date;
  availableDates = [];
  unAvailableDates = [];
  daysSelected: any[] = [];
  finalDate: Date;
  dayCalculate: number;
  checkingDates: any[];
  startDate: any = 0;
  endDate: any;
  calendar: any;
  requiredDates: boolean = false;
  isReqDateActive: boolean;
  filterListVehicleType: any[];
  VehicleTypeList: any = [];
  public showImplement: boolean = false;
  filterRegistrationNumbers: any[];
  registrationNumbers: any = [];
  uomTypeName: any;
  vehicleId: any;
  driverList: any[];
  filterListdriverList: any[];
  logBookData: any = [];
  refundHours: any;
  mhireReportType = 0;
  departmentBookingDetailViewModel: any;
  loading: boolean = false
  bookingHireDetailViewdata = [];
  bookingHireDetailViewdataSource = new MatTableDataSource(this.bookingHireDetailViewdata);
  bookingHireDetailViewdisplayedColumns: string[] = [
    "hireTs",
    "hireHours",
    "vehicleRegNo",
    "pvtDriverName",
    "pvtDriverMobileNo",
  ];

  setDisplayedColumns() {
    if (this.bookedHireData.vehicleCategoryName!=null) {
      this.bookingHireDetailViewdisplayedColumns = [
        "hireTs",
        "hireHours",
        "vehicleRegNo",
        "pvtDriverName",
        "pvtDriverMobileNo",
      ];
    } else {
      this.bookingHireDetailViewdisplayedColumns = ["hireTs"];
    }
  }

  bookingHistorydata = [
  ];
  bookingHistorydataSource = new MatTableDataSource(this.bookingHistorydata);
  bookingHistorydisplayedColumns: string[] = [
    "actions",
    "transactionTs",
    "paymentModeType",
    "paymentReceiptNo",
    "paidfor",
    "amount",
    "paymentRefNo",
    "paymentStatusTypeName",
  ];

  formValueArray: any = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("paginator1", { static: true }) paginator1: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) sort1: MatSort;
  bookedDates: any = [];
  pdfBase64: string;

  audio = new Audio();
  playDisplay: boolean = false;
  stopDisplay: boolean = false;

  hoursTotal: any = [];
  SplitTotalbookedHrs: any[];
  totalNoOfHours: any;
  totalNoOfallocatedHours: any;
  remainingHours: any;

  bookedallDates: any = [];
  startHireDate: any;
  endHireDate: any;
  nestedTabIndex: number;

  public RoleEnumType = RoleType;
  public CategoryEnumType = CategoryType;
  public StatusEnumType = BookingStatusType;
  roleId: number;
  AssistantEngineer: boolean;
  AssistantExecutiveEngineer: boolean;
  bookingId: any;
  pdfSource: any;
  languageType: any;
  controlAccess: any;
  cashPayment: boolean = false;
  landDevelopment: boolean;
  bookingDetaildata: any;
  PaymentId: number;
  isDepartmentBooking: boolean = false;
  vehicleGroupType: any;
  showAllocation: boolean;
  showDownload: boolean;
  TariffPerUnit: any;
  TotalBookingAmount: number;
  isPreInspection: any;
  session: any;
  dataId: any;
  subsityForm: FormGroup;
  subsidyDetailViewModel: any;
  farmerelegible: string;
  lastFour: any;
  farmerelegibleNo: boolean;
  farmerelegibleYes: boolean;
  subsidyelegible: string;
  farmerId: any;
  verify: any;
  clickdownload: boolean = true;
  aadharmask: any;
  totalWorkingArea: number;

  constructor(
    private formBuilder: FormBuilder,
    private _location: Location,
    route: ActivatedRoute,
    public dialog: MatDialog,
    private alertService: AlertService,
    private userSessionService: UserSessionService,
    // private regionService: RegionService,
    private translate: TranslateService,
    // private vehicleService: VehicleService,
    // private implementsService: ImplementsService,
    // private driverService: DriverService,
    private bookingService: BookingService,
    public navigationService: NavigationService,
    private farmerService: FarmerService,
    private securityService: SecurityService,
    // private reportService: ReportsService,
    private router: Router,
    @Optional() public dialogRef: MatDialogRef<ViewpvtbookingComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dataRecievedToView) {
    this.routeParams = route.snapshot.params;
    if (this.dataRecievedToView?.selectedData) {
      this.id = this.dataRecievedToView.selectedData
    }
    else {
      const decId = this.routeParams.id;
      this.id = this.securityService.decrypt(decId);
      this.actionInfo = this.routeParams.actionInfo;
      this.session = localStorage.getItem("BookingDetails");
      this.session = JSON.parse(this.session);
      this.isPreInspection = this.session?.isPreInspection;
      this.dataId = this.session?.id;
    }


    if (this.id === 0) {
      this.submitbtn = "Save";
    } else {
      this.submitbtn = "Save";
    }
    if (this.actionInfo == 1) {
      this.formEditMode = false;
    }

    this.clientId = this.userSessionService.getCurrentClientId();
    this.machineryAllocatesList = [];
    this.filterListmachineryAllocates = [];

    this.tommoDate = new Date(
      // moment(new Date()).add(1, "days").format("YYYY, MM, DD")
    );

    this.languageType = this.userSessionService.getLanguageType();

    this.controlAccess =
      this.userSessionService.getPageUrl("/pvtbooking");

    // this.bookedHireData = { mhireBookingDateViewModel: [] }

    this.availableDates = [];
    this.unAvailableDates = [];
    this.daysSelected = [];
    this.filterListVehicleType = [];
    this.VehicleTypeList = [];
    this.filterRegistrationNumbers = [];
    this.driverList = [];
    this.filterListdriverList = [];

    this.roleId = this.userSessionService.roleId();
    this.AssistantEngineer =
      this.roleId === this.RoleEnumType.AssistantEngineer ||
      this.roleId === this.RoleEnumType.Root;
    this.AssistantExecutiveEngineer =
      this.roleId === this.RoleEnumType.AssistantExecutiveEngineer ||
      this.roleId === this.RoleEnumType.Root;
  }
  ngOnInit(): void {
    this.initializeValidators();
    this.get(true);

  }

  onCancel() {
    if (this.dataRecievedToView?.selectedData) {
      this.dialogRef.close()
    }
    else {
      this._location.back();

    }
  }
  back(){
    if (this.dataRecievedToView?.selectedData) {
      this.dialogRef.close()
    }
    else {
    this._location.back();
    }
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      id: [this.id, Validators.required],
    });
  }


  //   someAsyncMethod() {
  //   return new Promise<void>((resolve) => {
  //     setTimeout(() => {
  //       resolve();
  //     }, 100);
  //   });
  // }

  // onTabChanged(event) {
  //   if (
  //     event.index == 1 &&
  //     // this.dealerTimeLineList.length == 0 &&
  //     this.id > 0
  //   ) {
  //    this.nestedTabIndex = 1;

  //     this.someAsyncMethod().then(() => {
  //       this.nestedTabIndex = 0;
  //     });

  //   }
  // }
  parseInt(val: any) {
    if (val === null || val === undefined || val === 'null') {
      return 0;
    }
    const cleanedVal = val.toString().replace(/"/g, '');
    const parsedVal = parseInt(cleanedVal, 10);
    return isNaN(parsedVal) ? 0 : parsedVal;
  }

  get(refresh: boolean) {
    this.loading = true;
    if (this.id > 0) {
      this.bookingService.getbookingListById(this.id, refresh).subscribe((result) => {
        this.bookedHireData = [];
        this.bookedHireData = result;
         this.setDisplayedColumns();
        this.bookedHireData.totalFarmArea = this.parseInt(this.bookedHireData.totalFarmArea)
        this.bookedHireData.totalWorkingArea = this.parseInt(this.bookedHireData.totalWorkingArea)
        this.bookingHireDetailViewdata = result.bookedAllocation;
        this.bookingHireDetailViewdataSource = new MatTableDataSource(this.bookingHireDetailViewdata);
        this.bookingHistorydata = result.paymentHistory;
        this.bookingHistorydataSource = new MatTableDataSource(this.bookingHistorydata);


        if (this.bookedHireData.totalHireHrs >= 8) {
          const days = parseInt(this.bookedHireData.totalHireHrs) - 2;
          var q = Math.floor(days / 8),
            r = days - q * 8;
          this.dayCalculate = r == 0 ? q : q + 1;
          this.requiredDates = true;
        } else {
          this.dayCalculate = 1;
          this.requiredDates = true;
        }
        this.isReqDateActive = true;
        if (this.bookedHireData) {
          this.form.patchValue(this.bookedHireData);
          if (
            this.bookedHireData.bookingStatusType ==
            this.StatusEnumType.Allocated
          ) {
            this.form.disable();
            // this.formEditMode = false
          }

        }
        this.loading = false
      });
      this.isReadOnly = true;
    }
  }

  convertToDate(timeStr: string): Date {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    const now = new Date();
    now.setHours(hours, minutes, seconds, 0);
    return now;
  }


  timeConverter(time: any): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':').map(Number);
    let result = '';
    if (hours) {
      result += `${hours} hours`;
    }
    if (minutes) {
      result += ` ${minutes} minutes`;
    }
    return result.trim();
  }

  openPopup() {
    const dialogRef = this.dialog.open(AeRemarksPopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: '800px',
      panelClass: 'mat-dialog',
      data: {
        item: this.bookedHireData,
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.alertService.success('Verified Successfully');
        this.onCancel();
      }
    });
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  approveCancellation(approvedStatusType: any, typename: string) {
    const title = 'Confirmation';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire(
      {
        title,
        text: `Are you sure you want to ${typename} the request?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }
    )
      .then(res => {
        if (res.value) {
          this.approveCancellationDisabled = true;
          let data = {
            id: this.bookedHireData.id,
            approvedStatusType: approvedStatusType,
            remarks: this.bookedHireData.cancellationRemarks,
            // pvtBookingCancelType: 0,
            // serviceProviderBookingCancelType:0
          };
          this.bookingService.phirebookingcancellation(data).subscribe(
            (response) => {
              if (response && response.isSuccess) {
                this.alertService.success(`${typename} Verified Successfully`);
                this._location.back();
                this.approveCancellationDisabled = false;
              } else {
                this.alertService.error(response.htmlFormattedFailures);
                this.approveCancellationDisabled = false;
              }
            });
        }
      });
  }

  downloadReceipt(type: number) {
    let data = {
      phireReportType:this.bookedHireData.applicationType==3?4:1,
      downloadType: 1,
      bookingId: this.bookedHireData.id,
      userId: 0,
      languageType: type
    }
    this.farmerService.downloadPhireReceiptdownload(data).subscribe(result => {
      if (result) {
        this.pdfSource = result.fileName;
        this.pdfLink = environment.imageBaseUrl + 'Receipt/' + this.pdfSource
        const downloadLink = document.createElement('a');
        const fileName = 'payment.pdf';
        downloadLink.href = this.pdfLink;
        downloadLink.download = fileName;
        downloadLink.target = '_blank';
        downloadLink.click();
      }
    });
  }
}
